import styled from "styled-components";

export const PlacementOptionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    .product-item-wrapper {
    display: flex;
    align-items: flex-start;
    grid-gap: 10px;
    img {
    width: 40px;
    height: 28px;
    object-fit: contain;
}
.product-item {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
}
.ag-cell{
  &:not(:first-child){
    border-left:1px solid #ECEFF1;
  }
}
footer{
  display: flex;
  justify-content: end;
  align-items: center;
  grid-gap: 16px;
}
.stats-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  grid-row-gap: 12px;
  margin-top: 12px;
  padding: 12px 16px;
  background: #fff;
  border: 1px solid #ECEFF1;
  border-radius: 4px;
  dl {
    margin: 0;
    display: flex;
    grid-column-gap: 28px;
    flex-wrap: wrap;
    grid-row-gap: 8px;
  }
  .stat {
    display: flex;
    flex-direction: column;
    grid-row-gap: 2px;
    dt {
      font-size: 11px;
      color: #808183;
    }
    dd {
      margin: 0;
      font-size: 14px;
      font-weight: 600;
      color: #16181D;
    }
  }
}
.ant-spin-nested-loading {
    position: relative;
    width: 100%;
}

.options-row {
  width: 100%;
  margin-bottom: 16px;
  &.loading-accured{
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    min-height: 120px;
    span.ant-spin-dot.ant-spin-dot-spin {
      margin-top: -20px;
    }
    .ant-spin-text {
      left: 0px;
    }
  }
}

.items-card {
  flex: 1;
  min-width: 0;
  min-height: 0;
  background: #fff;
  border: 1px solid #ECEFF1;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .items-card-header {
    display: flex;
    flex-direction: column;
    grid-row-gap: 2px;
    padding: 14px 16px;
    border-bottom: 1px solid #ECEFF1;
    h2 {
      margin: 0;
      font-size: 14px;
      font-weight: 600;
      color: #16181D;
      span {
        font-family: inherit;
        color: #4E5969;
        font-weight: 500;
      }
    }
    .items-card-sub {
      font-size: 12px;
      color: #808183;
    }
  }
}
`;
